import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Grid, Box, } from '@mui/material';
import { observer } from 'mobx-react-lite';
import AssetImage from '../../common/asset/AssetImage';
import { WysiwygViewer } from '../../../publisher/wysiwyg/WysiwygEditor';
const getCertificateStatus = (courseItem, progress) => {
    if (progress?.completedCertifications?.includes(courseItem?.certification)) {
        return 'Certification Completed';
    }
    return 'Certification Not Completed';
};
const CertificationLesson = ({ courseItem, progress }) => (_jsxs(Grid, { container: true, children: [_jsx(Grid, { item: true, sm: 12, children: courseItem.certificateMessage && (_jsx(Box, { className: "slate", sx: { bgcolor: 'common.white', p: 2, pt: 0 }, children: _jsx(WysiwygViewer, { id: "content", value: courseItem.certificateMessage.slate }) })) }), _jsx(Grid, { item: true, sm: 6, sx: {
                width: '100%',
            }, children: _jsx(AssetImage, { asset: courseItem.certification?.poster, size: "thumb400w", customStyle: {
                    maxHeight: '540px',
                    maxWidth: '100%',
                } }) }), _jsxs(Grid, { item: true, sm: 6, sx: {
                width: '100%',
            }, children: [courseItem.certificateDescription && (_jsx(Box, { className: "slate", sx: { bgcolor: 'common.white', p: 2, pt: 0 }, children: _jsx(WysiwygViewer, { id: "content", value: courseItem.certificateDescription?.slate }) })), progress && (_jsx(Box, { sx: { p: 2 }, children: getCertificateStatus(courseItem, progress) }))] })] }));
CertificationLesson.defaultProps = {
    progress: undefined,
};
export default observer(CertificationLesson);
//# sourceMappingURL=CertificationLesson.js.map